
import React from 'react'
import {withFirestore} from 'react-firestore'

import MsgNetLoading from '../components/MsgNetLoading'
import TopHeaderMenu from '../components/TopHeaderMenu'
import RankingSelector from '../components/RankingSelector'
import RankingResultadoList from '../components/RankingResultadoList'
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu'

import CONFIG from '../config'
import SharePanel from '../components/SharePanel'

class RankingScreen extends React.Component {
  // ...
  constructor (props) {
    super(props)
    this.state = {
      resultados: [],
      rankings: [],
      ranking: null,
      competicion: null,
      evento: null,
      showSharePanel: false
    }
    this.unlisten = {
      resultados: []
    }
  }

  componentDidMount () {
    const { firestore } = this.props
    // console.info(parseInt(this.props.match.params.competicionId, 10))
    const competicionId = parseInt(this.props.match.params.competicionId, 10)
    const rankingId = parseInt(this.props.match.params.rankingId, 10)

    this.unlisten.competicion = firestore.doc('competicion/' + competicionId).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      this.setState({ competicion })
    })

    this.unlisten.rankings = firestore.collection('ranking/')
      .where('competicion_id', '==', competicionId)
      .limit(CONFIG.NUMERO_MAXIMO_RANKINGS)
      .onSnapshot((snapshot) => {
        let rankings = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))

        let ranking = null
        if (rankingId) {
          ranking = rankings.filter((r) => parseInt(r.id, 10) === rankingId)
          if (ranking.length) {
            ranking = ranking[0]
          }
        } else if (rankings.length) {
          ranking = rankings[0]
        }
        this.setState({rankings, ranking})
      })
  }

  componentWillUpdate (nextProps, nextState) {
    const { firestore } = this.props

    if (this.state.competicion !== nextState.competicion) {
      if (nextState.competicion) {
        // Obtenemos el evento
        this.unlisten.evento = firestore.doc('evento/' + nextState.competicion.evento_id).onSnapshot(snapshot => {
          let evento = snapshot ? snapshot.data() : null
          if (evento) {
            evento.id = snapshot.id
          }
          this.setState({ evento })
        })
      }
    }

    if (this.state.ranking !== nextState.ranking) {
      if (nextState.ranking) {
        this.unlisten.resultados = firestore.collection('ranking_resultado/')
          .where('ranking_id', '==', parseInt(nextState.ranking.id, 10))
          .where('puesto', '>', 0)
          .orderBy('puesto', 'asc')
          .limit(CONFIG.NUMERO_MAXIMO_RESULTADOS)
          .onSnapshot((snapshot) => {
            let resultados = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }))
            this.setState({resultados})
          })
      }
    }

    if (this.props.match.params.rankingId !== nextProps.match.params.rankingId) {
      let ranking = null
      const rankingId = parseInt(nextProps.match.params.rankingId, 10)
      if (rankingId) {
        ranking = this.state.rankings.filter((r) => parseInt(r.id, 10) === rankingId)
        if (ranking.length) {
          ranking = ranking[0]
        }
      } else if (this.state.rankings.length) {
        ranking = this.state.rankings[0]
      }
      this.setState({ranking})
    }
  }

  onClickBack () {
    this.props.history.push(`/${this.state.competicion.evento_id}`)
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  componentWillUnmount () {
    // Desconectamos todos os "listeners" de firestore para evitar problemas de memoria
    if (this.unlisten.evento) {
      this.unlisten.evento()
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion()
    }
    if (this.unlisten.rankings) {
      this.unlisten.rankings()
    }
    if (this.unlisten.resultados) {
      this.unlisten.resultados()
    }
  }

  render () {
    const evento = this.state.evento
    const ranking = this.state.ranking
    const rankings = this.state.rankings
    const resultados = this.state.resultados
    const competicion = this.state.competicion

    if (competicion) {
      return <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={competicion}
          evento={evento}
        />
        <CompeticionHeaderMenu
          competicion={competicion} selected={2}
          evento={evento}
        />
        <RankingSelector competicion={competicion} rankings={rankings} ranking={ranking} />
        <RankingResultadoList ranking={ranking} resultados={resultados} />

        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}/ranking/${ranking.id}`}
            title={`${ranking.header} en la prueba ${competicion.nombre} (${evento.nombre})`}
          />
        )}

      </div>
    } else {
      return <MsgNetLoading />
    }
  }
}

export default withFirestore(RankingScreen)



// WEBPACK FOOTER //
// ./src/containers/RankingScreen.js